/*
 * Copyright (c) webzuu Michał Stambulski 2017.
 */

import React from "react";
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import SearchBox from "react-google-maps/lib/components/places/SearchBox";

const searchBoxInput = {
    boxSizing: "border-box",
    MozBoxSizing: "border-box",
    border: "1px solid transparent",
    width: "340px",
    height: "48px",
    marginBottom: "2rem",
    padding: "0 12px",
    borderRadius: "3px",
    fontSize: "1.4rem",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)",
    outline: "none",
    textOverflow: "ellipses",
};

const defaultMapCenter = {
    lat: 52.237049,
    lng: 21.017532,
};

const google = window.google;

const GettingStartedGoogleMap = withGoogleMap((props) => (
    <React.Fragment>
        <GoogleMap
            ref={props.onMapLoad}
            defaultZoom={5}
            center={
                props.center && props.center.lat
                    ? props.center
                    : defaultMapCenter
            }
            defaultCenter={defaultMapCenter}
            onClick={props.onMapClick}
        >
            {props.marker !== null ? (
                props.marker.position.lat !== undefined ? (
                    <Marker
                        {...props.marker}
                        onRightClick={() => props.onMarkerRightClick()}
                    />
                ) : null
            ) : null}
            <SearchBox
                ref={props.onSearchBoxMounted}
                controlPosition={
                    window.google.maps.ControlPosition.BOTTOM_CENTER
                }
                onPlacesChanged={props.onPlacesChanged}
            >
                <input
                    style={searchBoxInput}
                    type="text"
                    placeholder="Szukaj..."
                />
            </SearchBox>
        </GoogleMap>
    </React.Fragment>
));

export default class Map extends React.PureComponent {
    constructor(props) {
        super(props);
        this.defaultCenter =
            props.marker.position.lat === null
                ? defaultMapCenter
                : props.marker.position;

        this.center = this.defaultCenter;
    }

    handleMapLoad(map) {
        this._mapComponent = map;
    }

    handleSearchBoxMounted(searchBox) {
        this._searchBox = searchBox;
    }

    handleMapClick(event) {
        const marker = {
            position: event.latLng,
            key: Date.now(),
        };
        this.handleChange(marker.position);
    }

    handleMarkerRightClick() {
        this.handleChange(null);
    }

    handlePlacesChanged() {
        const place = this._searchBox.getPlaces()[0];
        const marker = {
            position: place.geometry.location,
            key: Date.now(),
        };
        this.center = marker.position.lat !== null ? marker.position : null;
        this.handleChange(marker.position);
    }

    handleChange = (latLng) => {
        this.props.setGeolocation({
            lat: latLng.lat(),
            lng: latLng.lng(),
        });
    };

    render() {
        return (
            <div
                style={{ height: "600px", width: "600px", maxHeight: "100vh" }}
            >
                <GettingStartedGoogleMap
                    containerElement={<div style={{ height: "100%" }} />}
                    mapElement={<div style={{ height: "100%" }} />}
                    defaultCenter={this.defaultCenter}
                    center={this.center}
                    onMapLoad={this.handleMapLoad.bind(this)}
                    onMapClick={this.handleMapClick.bind(this)}
                    onMarkerRightClick={this.handleMarkerRightClick.bind(this)}
                    onSearchBoxMounted={this.handleSearchBoxMounted.bind(this)}
                    onPlacesChanged={this.handlePlacesChanged.bind(this)}
                    marker={this.props.marker}
                />
            </div>
        );
    }
}
